import React from "react";
import { motion } from "framer-motion";
import StatsBand from "../components/StatsBand";
import BottomCTA from "../components/BottomCTA";
import AboutStory from "../components/about/AboutStory";
import AboutPrinciples from "../components/about/AboutPrinciples";
import AboutRegulation from "../components/about/AboutRegulation";

const OFFICE =
    "https://images.unsplash.com/photo-1765062166398-2ee2b6cbbbf1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBmaW5hbmNpYWwlMjBvZmZpY2UlMjBidWlsZGluZyUyMG5pZ2h0fGVufDB8fHx8MTc3ODE2MjU1NXww&ixlib=rb-4.1.0&q=85";

const heroEnter = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6 },
};

export default function AboutPage() {
    return (
        <div data-testid="about-page">
            <section className="relative pt-36 pb-20 overflow-hidden">
                <div className="absolute inset-0 -z-10">
                    <img
                        src={OFFICE}
                        alt=""
                        className="w-full h-full object-cover opacity-25"
                    />
                    <div className="absolute inset-0 bg-gradient-to-b from-[#050814]/70 via-[#050814]/85 to-[#050814]" />
                </div>
                <div className="xpo-container relative">
                    <motion.div {...heroEnter} className="max-w-4xl">
                        <p className="overline mb-4">About XPO Markets</p>
                        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white tracking-tight leading-[1.05]">
                            We build the rails so traders can focus on the
                            tape.
                        </h1>
                        <p className="text-slate-300 text-lg mt-6 max-w-2xl leading-relaxed">
                            XPO Markets is a global multi-asset broker
                            specialising in forex and crypto CFDs. Our mission
                            is to give serious retail traders the same
                            execution quality, tooling and discipline that
                            institutional desks rely on — without the
                            gatekeeping.
                        </p>
                    </motion.div>
                </div>
            </section>

            <StatsBand />
            <AboutStory />
            <AboutPrinciples />
            <AboutRegulation />
            <BottomCTA />
        </div>
    );
}
